import React from 'react';
import HarbourIcon from './HarbourIcon';
import './harbour.css';

/*
 * Harbour/Steps rail: the side card listing the steps of a form journey with
 * one step current. SEN has two steps, SENCo (add a pupil) has three in plum,
 * referral has four. Done steps show a tick instead of the number.
 */
export default function HarbourStepsRail({ tone = 'senco', steps = [], currentIndex = 0 }) {
  return (
    <ol className="harbour-steps" aria-label="Steps">
      {steps.map((label, i) => {
        const state = i < currentIndex ? 'done' : i === currentIndex ? 'current' : 'upcoming';
        return (
          <li
            key={label}
            aria-current={state === 'current' ? 'step' : undefined}
            className={`harbour-step harbour-step--${tone} harbour-step--${state}`}
          >
            <span className="harbour-step__disc" aria-hidden="true">
              {state === 'done' ? <HarbourIcon name="check" size={16} /> : i + 1}
            </span>
            {label}
          </li>
        );
      })}
    </ol>
  );
}
